'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserRatingsController = function () {
  function UserRatingsController(UsersService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, UserRatingsController);
    this.usersService = UsersService;
    this.$scope = $scope;
  }

  (0, _createClass3.default)(UserRatingsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      var isClient = this.userType === 'client';

      var dataSource = this.usersService.getRatingsDataSource(this.userId, isClient);

      dataSource.bind('requestEnd', function (e) {
        if (e.type === 'update' && e.response) {
          var totalRatingsAvg = e.response.totalRatingsAvg;
          if (totalRatingsAvg != null) {
            _this.onRatingUpdated({ totalRatingsAvg: totalRatingsAvg });
            _this.$scope.$apply();
          }
        }
      });

      this.gridOptions = {
        dataSource: dataSource,
        sortable: true,
        pageable: true,
        resizable: true,
        editable: 'inline',
        noRecords: {
          template: 'No Ratings.'
        },
        save: function save(e) {
          var item = e.model;
          var sum = item.category1 + item.category2 + item.category3 + item.category4;
          var avg = sum / 4.0;
          item.ratingSum = parseFloat(sum.toFixed(2));
          item.ratingAvg = parseFloat(avg.toFixed(2));
        },
        columns: [{ field: 'id', title: 'ID', width: '1.5rem', filterable: false }, { field: 'ratingById', title: 'Rated By ID', width: '2rem', filterable: false }, { field: 'firstName', title: 'First Name', width: '3rem', filterable: false }, { field: 'lastName', title: 'Last Name', width: '3rem', filterable: false }, { field: 'category1', title: 'Category 1', width: '2.5rem', filterable: false }, { field: 'category2', title: 'Category 2', width: '2.5rem', filterable: false }, { field: 'category3', title: 'Category 3', width: '2.5rem', filterable: false }, { field: 'category4', title: 'Category 4', width: '2.5rem', filterable: false }, { field: 'ratingSum', title: 'Rating Sum', width: '2.5rem', filterable: false }, { field: 'ratingAvg', title: 'Avg Rating', width: '2.5rem', filterable: false }, { field: 'ratingDate', title: 'Rating Date', width: '3rem', filterable: false, template: '#= kendo.toString(new Date(ratingDate), \'dd/MM/yyyy\') #' }, { command: ['edit'], title: 'Actions', width: '3rem' }]
      };
    }
  }]);
  return UserRatingsController;
}();

exports.default = UserRatingsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-ratings/user-ratings.controller.js
 **/